module.exports = __webpack_public_path__ + "static/media/languages.8836ab75.jpg";